import React from "react";
import styles from "./Footer.module.scss";
import { Link,useNavigate } from "react-router-dom";
const Footer = () => {
  const navigate = useNavigate();
  
    const handleNavigation = () => {
      navigate('/'); // Navigate to the specified route
    };
    const scrollToTop=()=>{
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Smooth scrolling
      });
    }
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* Logo and Address Section */}
        <div className={`${styles.footerSection} ${styles.logoSection}`}>
          <div className={styles.logo} onClick={handleNavigation}>
            <img src="/assests/sealkloudlogo.png" alt='logo'/>
          </div>
          {/* <div className={styles.officeDetails}>
            <h4 className={styles.officeTitle}>Office</h4>
            <address className={styles.officeAddress}>
              SealKloud Infotech Pvt Ltd<br/>
              4th Floor, ISR Towers PLOT NO-23,<br/>
              MUNICIPAL NO.1-118/23, Madhapur,<br/>
              ROHINI LAYOUT, Hyderabad,<br/>
              Rangareddy, Telangana, 50008
            </address>
            <br/>
            <h4 className={styles.officeTitle}>Phone</h4>
            <div>
            +91-9963500366
            </div>
          </div> */}
        </div>

        {/* Sealkloud Links */}
        <div className={styles.footerSection}>
          <h4>Sealkloud</h4>
          <ul>
            <li>
              <Link to="" onClick={() => scrollToTop()}>Home</Link>
            </li>
            <li>
              <Link to="/platforms" onClick={() => scrollToTop()}>Platforms</Link>
            </li>
          
            <li>
              <Link to="/contact" onClick={() => scrollToTop()}>Contact</Link>
            </li>
            <li>
              <Link to="/aboutus" onClick={() => scrollToTop()}>About Us</Link>
            </li>
            <li>
              <Link to="/privacy" onClick={() => scrollToTop()}>Privacy</Link>
            </li>
          </ul>
        </div>

        {/* Solutions Links */}
        <div className={styles.footerSection}>
          <h4>Solutions</h4>
          <ul>
            <li>
              <Link to="/services" onClick={() => scrollToTop()}>Services</Link>
            </li>
            <li>
              <Link to="/solutions" onClick={() => scrollToTop()}>SAP S/4Hana</Link>
            </li>
            <li>
              <Link to="/solutions" onClick={() => scrollToTop()}>Industrial Solutions</Link>
            </li>
            <li>
              <Link to="/solutions" onClick={() => scrollToTop()}>Omnichannel</Link>
            </li>
            <li>
              <Link to="/solutions" onClick={() => scrollToTop()}>SAP Forecast and Planing</Link>
            </li>
            <li>
              <Link to="/solutions" onClick={() => scrollToTop()}>SAP Logistics Solutions</Link>
            </li>
            <li>
              <Link to="/solutions" onClick={() => scrollToTop()}>Technical Solutions</Link>
            </li>
          </ul>
        </div>

        {/* Social Media Links */}
        {/* <div className={styles.footerSection}>
          <h4>Follow on Social Media</h4>
          <div className={styles.socialMedia}>
            <a href="#">
              <i className="fa fa-linkedin"></i>
            </a>
            <a href="#">
              <i className="fa fa-twitter"></i>
            </a>
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div> */}
      </div>

      {/* Bottom Copyright Section */}
      <div className={styles.footerBottom}>
        <p>Copyright © 2025 Sealkloud | All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
